var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"el-export",attrs:{"target":"blank","href":_vm.linkToDownloadCsv}},[_vm._v("Export to CSV")])
}
var staticRenderFns = []

export { render, staticRenderFns }